import { connect } from 'react-redux';
import { get } from 'lodash';
import Quiz from '../components/Quiz';
import dataFetcher from './DataFetcher';
import * as MyAppsActions from '../actions/myapps';
import { FptiHelper } from '../lib/fptiHelper';

const mapStateToProps = state => {
  const { app = {}, experimentation = {} } = state;
  let fptiHelper = new FptiHelper({ app, experimentation });

  return {
    app,
    experimentation,
    fptiHelper,
    tools: get(state, 'myapps.tools', {}),
    productcompletion: get(state, 'productcompletion', {})
  };
};

const Wrapper = dataFetcher(Quiz, [MyAppsActions.fetchTools]);
export default connect(mapStateToProps)(Wrapper);
